/**
 * AZ AUDIT-NAPLÓ TÍPUSAINAK MAGYAR NEVE [Web UX 3. csomag (C), 2026-10-04]
 *
 * MI VOLT A BAJ (`Documents/WEB_UX_JAVASLATOK_2026-10-02.md` 1.6): a „Entitás típus" szűrő és a
 * táblázat oszlopa a backend NYERS osztályneveit mutatta („CoachPayment", „EventRegistration",
 * „PlannedRecurringEvents"…) — a magyar felületen egy klub-admin ezekből nem tudja kitalálni,
 * mit keres.
 *
 * A LISTA FORRÁSA (mérve 2026-10-04):
 *  • az ÉLŐ lokális API (`GET /api/AuditLog/entity-types`, :5229, admin) 18 értéket adott:
 *    Authentication, CoachAvailability, CoachAvailabilitySeries, CoachPayment, Email, Event,
 *    EventRegistration, Events, EventTypes, Message, PlannedRecurringEvents, PrivateLessonRequest,
 *    SosAccessLog, TableReservation, User, UserProfile, Users, Venues;
 *  • a backend KÓDJA további 5-öt írhat, ami a lokális DB-ben még nem fordult elő (a
 *    `LogAsync`/`LogCreateAsync`/`LogUpdateAsync`/`LogDeleteAsync` hívások és az
 *    `EntityType = "…"` hozzárendelések végigolvasva): ClientError (`ClientErrorsController.cs:72`),
 *    DataRetention (`DataRetentionController.cs:63`), EventAttendance (`AttendanceController.cs:219`,
 *    `EventController.cs:2155`), EventOperations (`EventController.cs:2549`), EventPayments
 *    (`EventController.cs:2323`).
 *  ⚠️ A backendben a nevek VEGYESEK: egyes és többes szám is előfordul, és NEM ugyanazt jelentik:
 *    „Events" = az esemény létrehozása/módosítása/törlése (`EventController.cs:535`, :946, :1084),
 *    „Event" = a jelenléti ív tömeges mentése (`AttendanceController.cs:458`,
 *    `ATTENDANCE_BULK_UPDATE`); „Users" = a felhasználó-kezelés (`UsersController.cs:1454`),
 *    „User" = a fiók-műveletek (e-mail megerősítés, jelszó-visszaállítás, törlés-kérés, adattörlés —
 *    `AuthController.cs:280, :488, :621`, `DataRetentionController.cs:117`). A szűrő egyszerre
 *    EGY nyers típusra szűr (a backend nem fogad listát), ezért a két-két név KÜLÖN felirattal
 *    szerepel — két egyforma „Esemény" sor a legördülőben megtévesztő lenne.
 *  • ISMERETLEN (jövőbeli) típus → a nyers név marad (nem tűnik el a listából).
 */
export const AUDIT_ENTITY_TYPE_LABELS: Record<string, string> = {
  Authentication: 'Bejelentkezés',
  ClientError: 'Kliens hiba',
  CoachAvailability: 'Edzői elérhetőség',
  CoachAvailabilitySeries: 'Edzői elérhetőség-sorozat',
  CoachPayment: 'Edzői kifizetés',
  DataRetention: 'Adatmegőrzés (lejárt naplók)',
  Email: 'E-mail',
  Event: 'Esemény – jelenléti ív',
  EventAttendance: 'Jelenlét',
  EventOperations: 'Esemény operatív adatai',
  EventPayments: 'Esemény fizetései',
  EventRegistration: 'Jelentkezés',
  Events: 'Esemény',
  EventTypes: 'Eseménytípus',
  Message: 'Üzenet',
  PlannedRecurringEvents: 'Heti beosztás (ismétlődő esemény)',
  PrivateLessonRequest: 'Magánóra-igénylés',
  SosAccessLog: 'SOS-hozzáférés',
  TableReservation: 'Asztalfoglalás',
  User: 'Felhasználói fiók (e-mail, jelszó, törlés)',
  UserProfile: 'Felhasználói adatlap',
  Users: 'Felhasználó',
  Venues: 'Helyszín',
};

/** A típus magyar neve; ismeretlen (vagy üres) típusnál a NYERS érték. */
export const auditEntityTypeLabel = (type: string | null | undefined): string => {
  if (!type) return '';
  return Object.prototype.hasOwnProperty.call(AUDIT_ENTITY_TYPE_LABELS, type)
    ? AUDIT_ENTITY_TYPE_LABELS[type]
    : type;
};
